import type { PlatformTenant } from "../../platform/types";
import { createPlatformPageExtensions } from "../../extensions/platformPages";
import {
  sailPlotCustomizedPageTitle,
  sailPlotFaviconDataUrl,
} from "../../platform/sailplotFavicon";
import { coreAssets } from "../coreAssets";
import examplePartnerLogo from "./assets/example-partner-logo.svg";

export const exampleTenant = {
  id: "example",
  domains: ["example.sailplot.app", "example-sandbox.sailplot.app"],
  config: {
    branding: {
      appName: "Example Plot Demo",
      shortName: "Example Plot",
      logo: coreAssets.sailplotLogoLight,
      logoDark: coreAssets.sailplotLogoDark,
      compactLogo: coreAssets.sailplotIcon,
      logoAlt: "SailPlot",
      favicon: sailPlotFaviconDataUrl("#9A031E"),
      partnerName: "Your Logo Here",
      partnerLabel: "",
      partnerLogo: examplePartnerLogo,
      exportWatermarkLogo: examplePartnerLogo,
      exportProductLogo: coreAssets.sailplotLogoLight,
    },
    theme: {
      mode: "light",
      usePrimaryForBrandAccents: true,
      qrFinderColor: null,
      light: {
        primary: "#9a031e",
        primaryText: "#ffffff",
        accent: "#f97316",
      },
      dark: {
        primary: "#9a031e",
        primaryText: "#ffffff",
        accent: "#fb923c",
      },
    },
    texts: {
      footerText: "Example tenant demo",
    },
    links: {
      app: "https://example.sailplot.app/",
      support: "https://example.com/support",
      website: null,
      privacy: null,
      imprint: null,
    },
    ui: {
      help: false,
      canvasBrandingLinks: false,
      poweredBySailPlot: false,
    },
    objectColors: {
      markColorMode: "sailplot",
      markCustomColor: null,
      startLineFlagColor: "#FF5E00",
    },
    localization: {
      languageMode: "both",
    },
    pageTitle: sailPlotCustomizedPageTitle("Example Plot Demo"),
    storageNamespace: "sailplot-platform-example",
  },
  extensions: createPlatformPageExtensions({
    hostingProvider: "cloudflare-pages",
    imprint: false,
    instructions: true,
    makeYourOwn: true,
    openSource: true,
    privacy: false,
    hostedForCustomer: true,
    sailPlotLegalBaseUrl: "https://sailplot.app/",
  }),
} satisfies PlatformTenant;
